import * as BlockComponents from "../blocks"

export const getBlockTypeKey = (type) => {
  // return the proper key for a block
  return Object.keys(BlockComponents).find(
    (k) => k.toLowerCase() === type.toLowerCase()
  )
}

export const getBlock = (type, mode) => {
  const typeName = getBlockTypeKey(type)
  if (!typeName || !BlockComponents[typeName])
    throw new Error(
      `No block type ${typeName} found. Are you sure you exported it from ./blocks/index?`
    )
  return BlockComponents[typeName][mode.toLowerCase()]
}
